import * as React from "react";
const SvgBurgerMenu = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4 37.6667H44V33.2222H4V37.6667ZM4 26.5556H44V22.1111H4V26.5556ZM4 11V15.4444H44V11H4Z", fill: "#313336" }));
export default SvgBurgerMenu;
